import React from "react";
import logo from "../assets/splash-logo.png";
import eclipse from "../assets/splash-eclipse.png";
import './LoadingScreen.css';

const LoadingScreen = () => {
  return (
<div className="loading-container">
      {/* Eclipse fixed bottom-left */}
      <img src={eclipse} alt="Background shape" className="custom-eclipse" />

      {/* Centered Logo */}
      <img src={logo} alt="Logo" className="custom-logo" />
    </div>
  );
};

export default LoadingScreen;
